import { useMemo } from 'react';

import clsxm from '@/lib/clsxm';

import CarouselPage from '@/features/carousel/components/carousel-page';
import useSwipeable from '@/features/carousel/hooks/use-swipeable';

import { CarouselItem } from '../types';

type CarouselGridProps = {
  items: CarouselItem[];
  currentPage: number;
  setCurrentPage: (page: number) => void;
  perPage: number;
};

export default function CarouselGrid(props: CarouselGridProps) {
  const swipeable = useSwipeable({
    page: props.currentPage,
    onPageChange: props.setCurrentPage,
  });

  const carouselPages = useMemo(() => {
    return props.items.reduce((rows, item, index) => {
      const rowIndex = Math.floor(index / props.perPage);
      rows[rowIndex] ??= [];
      rows[rowIndex].push(item);

      return rows;
    }, [] as CarouselItem[][]);
  }, [props.items, props.perPage]);

  return (
    <div className='flex w-full overflow-x-hidden' {...swipeable}>
      {carouselPages.map((row, index) => {
        return (
          <div
            key={index}
            className={clsxm(
              'flex min-w-full flex-nowrap p-1 transition-all duration-150 ease-linear'
            )}
          >
            <CarouselPage {...props} items={row} />
          </div>
        );
      })}
    </div>
  );
}
